"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultManagementSchema = void 0;
exports.defaultManagementSchema = {
    type: 'object',
    required: ['toolApplied'],
    properties: {
        approvedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        toolApplied: {
            type: 'boolean',
            errorMessage: 'should be between true or false',
        },
        toolDetail: {
            type: 'string',
            minLength: 1,
            maxLength: 1000,
            errorMessage: 'should be a string with maximum of 1000 characters',
        },
    },
};
exports.default = exports.defaultManagementSchema;
